import { Tabs as Mui4Tabs, TabsProps as Mui4TabsProps } from '@material-ui/core'
import { default as Mui5Tabs, TabsProps as Mui5TabsProps } from '@mui/material/Tabs'
import { forwardRef } from 'react'
import { useComponentVersion } from '../../hooks/useComponentVersion'

export enum OsTabsVersion {
  V1 = 1, // MUI4 + OS Theme
  V2 = 2, // MUI5 + Stratis
}

export type TabsType = 'segmented' | 'tab'

export type TabsProps = Mui5TabsProps & { type?: TabsType }

export const Tabs = forwardRef<HTMLDivElement, TabsProps>((props, ref) => {
  const { type, ...rest } = props
  const version = useComponentVersion('tabs')

  switch (version) {
    case OsTabsVersion.V2:
      return <Mui5Tabs type={type} ref={ref} {...(rest as Mui5TabsProps)} />
    default:
      return <Mui4Tabs {...((rest as unknown) as Mui4TabsProps)} />
  }
})

declare module '@mui/material/Tabs' {
  interface TabsOwnProps {
    type?: TabsType
  }
}
